import { render, staticRenderFns } from "./ConsultantPromotionSteps.vue?vue&type=template&id=157d4948"
import script from "./ConsultantPromotionSteps.vue?vue&type=script&lang=js"
export * from "./ConsultantPromotionSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports